import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { DialogService } from 'primeng/dynamicdialog';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEsPe from '@angular/common/locales/es-PE';
import { APP_CONFIG, PROMOTORES_APP_CONFIG } from '@ribera-web/app-token';
import { environment } from '../environments/environment';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authRefreshInterceptor } from '@ribera-web/auth-data-acess';
import { HttpLoadingInterceptor } from '@ribera-web/http-loading';

registerLocaleData(localeEsPe, 'es-PE');
console.log('CONFIG TOKEN:', PROMOTORES_APP_CONFIG);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes, withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'es-PE' },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.my-app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    provideHttpClient(
      withInterceptors([HttpLoadingInterceptor, authRefreshInterceptor])
    ),
    {
      provide: APP_CONFIG,
      useValue: environment,
    },
    {
      provide: PROMOTORES_APP_CONFIG,
      useValue: environment,
    },
    provideOAuthClient(),
    DialogService
  ],
};
